import React from "react";
import { bodyStyleData } from "../../../../data/category/inputData";
import CheckboxFilter from "../Common/CheckboxFilter";

const BodyStyle = () => {
  return (
    <CheckboxFilter
      title="Body Style"
      filterData={bodyStyleData}
      filterName="bodyStyle"
    />
  );
};

export default BodyStyle;
